<video height="360" controls>
    <source [src]="props.src" type="video/mp4">
</video>